// extracted by mini-css-extract-plugin
export default {"canvas-box":"_7tKurRcrQPopceQIaBbXMg=="};